const courses = [
  {
    code: "01",
    title: "Sirena",
    duration: "6 semanas",
    level: "Iniciático",
    text: "Imagen vocal. Domina tu herramienta vocal.",
    image: "/course-sirena.png",
  },
  {
    code: "02",
    title: "A.B.C.",
    duration: "8 semanas",
    level: "Intermedio",
    text: "Always be calibrating. Amplio manual de referencia sobre lenguaje corporal.",
    image: "/course-abc.png",
  },
  {
    code: "03",
    title: "P.I.A.",
    duration: "10 semanas",
    level: "Intermedio",
    text: "Persuasión, Influencia y Autoridad. Domina tu comunicación global para generar impacto a tu favor.",
    image: "/course-pia.png",
  },
  {
    code: "04",
    title: "A.M.P.",
    duration: "12 semanas",
    level: "Avanzado",
    text: "Amplifica tu Influencia.",
    image: "/course-amp.png",
  },
  {
    code: "05",
    title: "O.L.A.",
    duration: "8 semanas",
    level: "Avanzado",
    text: "Operativo Lectura Avanzada. Domina el lenguaje corporal y el comportamiento subconsciente.",
    image: "/course-ola.png",
  },
  {
    code: "06",
    title: "Physiognosis",
    text: "Código Facial. Lectura efectiva del rostro.",
    image: "/course-physiognosis.png",
  },
  {
    code: "07",
    title: "Imperium",
    text: "Autoridad natural y capacidad de influencia.",
    image: "/course-imperium.png",
  },
  {
    code: "08",
    title: "Hermeneia",
    text: "Audio programa sobre simbolismo, comunicación y subconsciente.",
    image: "/course-hermeneia.png",
  },
  {
    code: "09",
    title: "P.I.A. 2",
    text: "Continuación avanzada de P.I.A. Persuasión, Influencia y Autoridad.",
    image: "/course-pia2.png",
  },
];

export default function Courses() {
  return (
    <section
      id="cursos"
      data-testid="courses-section"
      className="relative py-20 lg:py-28 bg-[#030303] border-t border-[#B49A6C]/10"
    >
      <div className="absolute inset-0 pattern-rule opacity-60" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-20">
          <div className="max-w-2xl">
            <p className="text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-10 flex items-center gap-4">
              <span className="h-px w-12 bg-[#B49A6C]/50" />
              II — Programas
            </p>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Múltiples programas.
              <span className="block italic text-metal mt-2">
                Premium.
              </span>
            </h2>
          </div>
          <p className="text-[#807C70] max-w-sm leading-relaxed font-light">
            Programas verticales y secuenciales. Cada uno se sostiene por sí
            mismo, todos juntos forman el camino hacia la maestría.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#B49A6C]/10">
          {courses.map((c) => (
            <article
              key={c.code}
              data-testid={`course-card-${c.code}`}
              className="group relative bg-[#0A0A0B] p-8 lg:p-10 transition-colors duration-700 hover:bg-[#101012] cursor-pointer"
            >
              <div className="relative aspect-[4/3] mb-8 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale brightness-75 group-hover:grayscale-0 group-hover:brightness-90 transition-all duration-1000"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent" />
              </div>

              <div className="flex items-baseline justify-between mb-4">
                <span className="font-display font-light text-2xl text-metal">
                  {c.code}
                </span>
              </div>

              <h3 className="font-display font-light text-xl lg:text-2xl text-[#E8E5DC] mb-3 font-normal leading-tight">
                {c.title}
              </h3>
              <p className="text-[#807C70] text-sm leading-relaxed mb-6 font-light">
                {c.text}
              </p>
              <div className="pt-6 border-t border-[#B49A6C]/10 flex items-center justify-end">
                <span className="text-[#B49A6C] text-sm group-hover:translate-x-1 transition-transform duration-500">
                  →
                </span>
              </div>
            </article>
          ))}
        </div>

        <div
          data-testid="courses-note"
          className="mt-20 max-w-3xl mx-auto text-center"
        >
          <div className="divider-metal mb-10" />
          <p
            className="text-base lg:text-lg font-light tracking-wide leading-loose"
            style={{
              background:
                "linear-gradient(180deg, #E8E5DC 0%, #C9C2B0 50%, #7A7468 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              color: "transparent",
            }}
          >
            Todos los programas están grabados en calidad 4K y audio de estudio.
          </p>
          <p
            className="mt-6 text-base lg:text-lg font-light tracking-wide leading-loose"
            style={{
              background:
                "linear-gradient(180deg, #E8E5DC 0%, #C9C2B0 50%, #7A7468 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
              color: "transparent",
            }}
          >
            Además de los videos con el contenido premium, recibes acceso a
            infográficos y presentaciones para reforzar tu aprendizaje.
          </p>
        </div>
      </div>
    </section>
  );
}
